<template>
  <div id="app">
    <RouterView />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
#app {
  margin: 0;
  padding: 0;
}
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {}
</style>
